import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Footprint} from "../model/asax-sky-view.model";


@Injectable({
  providedIn: 'root'
})
export class AsaxSkyViewService {
  private raDecFovSubject = new Subject<[number, number, number]>();

  private footprintClickedSubject = new Subject<Footprint>();
  private footprintHoveredSubject = new Subject<Footprint>();
  private searchRadiusHoveredSubject = new Subject<Footprint>();

  getRaDecFov(): Observable<[number, number, number]> {
    return this.raDecFovSubject.asObservable();
  }

  setRaDecFov(raDecFov: [number, number, number]): void {
    this.raDecFovSubject.next(raDecFov);
  }

  getFootprintHovered(): Observable<Footprint> {
    return this.footprintHoveredSubject.asObservable();
  }

  setFootprintHovered(footprint: Footprint): void {
    this.footprintHoveredSubject.next(footprint);
  }

  getSearchRadiusHovered(): Observable<Footprint> {
    return this.searchRadiusHoveredSubject.asObservable();
  }

  setSearchRadiusHovered(footprint: Footprint): void {
    this.searchRadiusHoveredSubject.next(footprint);
  }

  getFootprintClicked(): Observable<Footprint> {
    return this.footprintClickedSubject.asObservable();
  }

  setFootprintClicked(footprint: Footprint): void {
    this.footprintClickedSubject.next(footprint);
  }
}
